import React from 'react'
import { string, array, shape } from 'prop-types'
import 'intersection-observer'
import { css } from '@emotion/react'
import { graphql } from 'gatsby'

import AppsList from '@/components/HomePage/AppsList'
import Sidebar from '@/components/Services/Sidebar'
import mediaQueries from '@/layout/media-queries'
import EnhancedListProvider from '@/context/EnhancedList'
import Developer from '@/components/Developer'
import SEO from '@/components/SEO'
import Layout from '@/layout'

const appsListCss = css`
  margin-top: 120px;

  > div {
    margin-bottom: 0;
  }
`

const overrideStyles = {
  container: {
    marginBottom: '60px',

    [mediaQueries.smallScreen()]: {
      marginBottom: '0px',
    },
  },
}

const DeveloperTemplate = ({ data: { developer } }) => {
  if (!developer) return null

  return (
    <EnhancedListProvider>
      <Layout overrideStyles={overrideStyles} developer={developer}>
        <SEO
          title={`${developer.company} | LiveChat Marketplace Developer`}
          description={`${developer.bio}`}
          path={`/developers/${developer.slug}/`}
        />
        <Developer developer={developer} sidebarComponent={Sidebar} />
        <AppsList css={appsListCss} />
      </Layout>
    </EnhancedListProvider>
  )
}

DeveloperTemplate.propTypes = {
  data: shape({
    developer: shape({
      id: string,
      bio: string,
      contactEmail: string,
      name: string,
      twitter: string,
      slug: string,
      apps: array,
      services: array,
    }),
  }),
}

export default DeveloperTemplate

export const query = graphql`
  query($developerId: String!) {
    developer(id: { eq: $developerId }) {
      apps {
        icons {
          id
          large
          original
          small
          title
        }
        slug
        id
        name
        product
        payment {
          creditCardRequired
          frequency
          trialDays
          price
          perAccount
        }
        shortDescription
      }
      services {
        icons {
          id
          large
          original
          small
          title
        }
        slug
        id
        name
        product
        payment {
          creditCardRequired
          frequency
          perAccount
          price
          trialDays
        }
        shortDescription
      }
      bio
      contactEmail
      id
      name
      slug
      twitter
      github
      website
      company
    }
  }
`
